export const Icons20x20 = {
    refresh: 'icon-en_icon_20x20_aktualisieren',
    arrowDown: 'icon-en_icon_20x20_arrow_down',
    arrowLeft: 'icon-en_icon_20x20_arrow_left',
    arrowRight: 'icon-en_icon_20x20_arrow_right',
    arrowUp: 'icon-en_icon_20x20_arrow_up',
    check: 'icon-en_icon_20x20_bestaetigen',
    remove: 'icon-en_icon_20x20_entfernen',
    question: 'icon-en_icon_20x20_frage',
    download: 'icon-en_icon_20x20_herunterladen',
    add: 'icon-en_icon_20x20_hinzufuegen',
    calendar: 'icon-en_icon_20x20_kalender',
    close: 'icon-en_icon_20x20_schliessen',
    search: 'icon-en_icon_20x20_suche',
    tableExpanded: 'icon-en_icon_20x20_tabelle_aufgeklappt',
    tableNotExpanded: 'icon-en_icon_20x20_tabelle_zugeklappt',
    chevronDown: 'icon-en_icon_20x20_vektor_dow',
    chevronLeft: 'icon-en_icon_20x20_vektor_left',
    chevronRight: 'icon-en_icon_20x20_vektor_right',
    chevronUp: 'icon-en_icon_20x20_vektor_up',
    edit: 'icon-en_icon_20x20_bearbeiten',
    options: 'icon-en_icon_20x20_optionen',
    statistic: 'icon-en_icon_20x20_statistik',
};
export const Icons32x32 = {
    settings: 'icon-en_icon_32x32_einstellungen_02',
    feedback: 'icon-en_icon_32x32_feedback_geben',
    garden: 'icon-en_icon_32x32_freiflaeche_garten',
    business: 'icon-en_icon_32x32_gewerbe',
    information: 'icon-en_icon_32x32_information',
    calendar: 'icon-en_icon_32x32_kalender',
    copy: 'icon-en_icon_32x32_kopieren',
    storageRoom: 'icon-en_icon_32x32_lagerraum',
    bin: 'icon-en_icon_32x32_loeschen',
    marker: 'icon-en_icon_32x32_markieren',
    persons: 'icon-en_icon_32x32_mieter',
    rentalContract: 'icon-en_icon_32x32_mietvertrag',
    object: 'icon-en_icon_32x32_objekt',
    protocol: 'icon-en_icon_32x32_protokoll',
    hotlinePerson: 'icon-en_icon_32x32_service-hotline_01',
    hotlineChat: 'icon-en_icon_32x32_service-hotline_02',
    saveFile: 'icon-en_icon_32x32_speichern',
    saveDisc: 'icon-en_icon_32x32_speichern_1',
    location: 'icon-en_icon_32x32_standort',
    parkingSpotSign: 'icon-en_icon_32x32_stellplatz_01',
    parkingSpot: 'icon-en_icon_32x32_stellplatz_02',
    search: 'icon-en_icon_32x32_suche',
    share: 'icon-en_icon_32x32_teilen',
    zoomIn: 'icon-en_icon_32x32_vergroessern_1',
    zoomOut: 'icon-en_icon_32x32_verkleinern_1',
    restore: 'icon-en_icon_32x32_wiederherstellen',
    meter: 'icon-en_icon_32x32_zaehler',
    meterGas: 'icon-en_icon_32x32_zaehler_gas',
    meterOil: 'icon-en_icon_32x32_zaehler_oel',
    meterElectric: 'icon-en_icon_32x32_zaehler_strom',
    meterHeat: 'icon-en_icon_32x32_zaehler_waerme',
    meterWater: 'icon-en_icon_32x32_zaehler_wasser',
    merge: 'icon-en_icon_32x32_zu_akte_zusammenfassen',
    select: 'icon-en_icon_32x32_auswaehlen',
    user: 'icon-en_icon_32x32_benutzer',
    saveImage: 'icon-en_icon_32x32_bild_speichern',
    delegate: 'icon-en_icon_32x32_delegieren',
    options: 'icon-en_icon_32x32_einstellungen_01',
    key: 'icon-en_icon_32x32_schluessel',
    apartment: 'icon-en_icon_32x32_wohnung',
    file: 'icon-en_icon_32x32_akte',
    crop: 'icon-en_icon_32x32_zuschneiden',
    scale: 'icon-en_icon_32x32_flaeche',
    enloc: 'icon-enloc_logo_min',
    dashboard: 'icon-icon_dashboard',
};
export const Icons16x16 = {
    add: 'icon-en_icon_16x16_hinzufuegen',
    remove: 'icon-en_icon_16x16_entfernen',
    help: 'icon-en_icon_16x16_hilfe',
    helpAlt: 'icon-en_icon_16x16_belieferung_nicht_gefunden',
    menu: 'icon-en_icon_16x16_menu',
    bin: 'icon-en_icon_16x16_maelleimer',
    error: 'icon-en_icon_16x16_fehler',
    cancel: 'icon-en_icon_16x16_zaehler_ausgebaut',
    cancelAlt: 'icon-en_icon_16x16_keine_belieferung',
    power: 'icon-en_icon_16x16_zaehler_deaktiviert',
    export: 'icon-en_icon_16x16_exportieren',
    warningSign: 'icon-en_icon_16x16_externe_nacharbeit',
    download: 'icon-en_icon_16x16_herunterladen',
    upload: 'icon-en_icon_16x16_hochladen',
    calendar: 'icon-en_icon_16x16_kalender',
    warning: 'icon-en_icon_16x16_interne_nacharbeit',
    tableColumnMoveForward: 'icon-en_icon_16x16_spalte_an_erste_stelle',
    tableColumnMoveBackward: 'icon-en_icon_16x16_spalte_an_letzte_stelle',
    tableExport: 'icon-en_icon_16x16_tabelle_exportieren',
    car: 'icon-en_icon_16x16_stellplatz',
    house: 'icon-en_icon_16x16_wohnung',
    arrowForward: 'icon-en_icon_16x16_zaehler_aktiv',
    arrowBack: 'icon-en_icon_16x16_zurueck',
    close: 'icon-en_icon_16x16_anmeldung_fehlgeschlagen',
    document: 'icon-en_icon_16x16_dokument',
    pen: 'icon-en_icon_16x16_editieren',
    key: 'icon-en_icon_16x16_wohnungszaehler',
    eye: 'icon-en_icon_16x16_passwort_anzeigen',
    check: 'icon-en_icon_16x16_bestaetigen',
    checkCircle: 'icon-en_icon_16x16_bereit_fuer_anmeldung',
    checkCircleAlt: 'icon-en_icon_16x16_',
    refresh: 'icon-en_icon_16x16_aktualisieren',
    clock: 'icon-en_icon_16x16_belieferung_auslaufend',
    refreshAlt: 'icon-en_icon_16x16_belieferung_laeuft',
    mediumHeat: 'icon-en_icon_16x16_waerme',
    mediumGas: 'icon-en_icon_16x16_gas',
    mediumOil: 'icon-en_icon_16x16_oel',
    mediumElectricity: 'icon-en_icon_16x16_strom',
    mediumWater: 'icon-en_icon_16x16_wasser',
};
